const RELATIVE_UNITS_MS = Object.freeze({
    minute: 60 * 1000,
    minutes: 60 * 1000,
    hour: 60 * 60 * 1000,
    hours: 60 * 60 * 1000,
    day: 24 * 60 * 60 * 1000,
    days: 24 * 60 * 60 * 1000,
    week: 7 * 24 * 60 * 60 * 1000,
    weeks: 7 * 24 * 60 * 60 * 1000,
})

function parseObjectIdTimestamp(value){
    if( typeof value !== "string" || value.length < 8 || !/^[a-fA-F0-9]{24}$/.test(value) ){
        return undefined
    }
    const seconds = Number.parseInt(value.slice(0, 8), 16)
    if( !Number.isFinite(seconds) ){
        return undefined
    }
    const date = new Date(seconds * 1000)
    return Number.isNaN(date.getTime()) ? undefined : date.toISOString()
}

export function primitiveTimestampFallback(primitive, field){
    if( !primitive ){
        return undefined
    }
    const direct = primitive?.[field]
    if( direct ){
        const date = direct instanceof Date ? direct : new Date(direct)
        if( !Number.isNaN(date.getTime()) ){
            return date.toISOString()
        }
    }
    return parseObjectIdTimestamp(primitive.id ?? primitive._id?.toString?.())
}

function resolveRelativeDateOperand(value, now = new Date()){
    if( !value || typeof value !== "object" || Array.isArray(value) || value.mode !== "relative" ){
        return value
    }
    const anchor = value.anchor === "now" || !value.anchor ? now : new Date(value.anchor)
    if( Number.isNaN(anchor.getTime()) ){
        return undefined
    }
    const amount = Number(value.amount ?? 0)
    const unitMs = RELATIVE_UNITS_MS[value.unit] ?? RELATIVE_UNITS_MS.day
    const delta = Number.isFinite(amount) ? amount * unitMs : 0
    const direction = value.direction === "after" ? 1 : -1
    return new Date(anchor.getTime() + (delta * direction)).toISOString()
}

export function normalizeDateFilterValue(value, now = new Date()){
    if( value === undefined || value === null || value === "" ){
        return undefined
    }
    const resolved = resolveRelativeDateOperand(value, now)
    if( resolved === undefined || resolved === null || resolved === "" ){
        return undefined
    }
    if( typeof resolved === "string" ){
        const date = new Date(resolved)
        return Number.isNaN(date.getTime()) ? undefined : date.toISOString()
    }
    const date = resolved instanceof Date ? resolved : new Date(resolved)
    return Number.isNaN(date.getTime()) ? undefined : date.toISOString()
}

export function isTopLevelPrimitiveDateField(field){
    return field === "createdAt" || field === "updatedAt"
}
